import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-print-report',
  templateUrl: './print-report.component.html',
  styleUrls: ['./print-report.component.scss']
})
export class PrintReportComponent {
  selectedReportType: string = ''; 

  constructor(public dialogRef: MatDialogRef<PrintReportComponent>) {}


  onSelectionChange(reportType: string) {
    this.selectedReportType = reportType;
    console.log('Report Type Selected:', this.selectedReportType);  
  }

  closeModal() {
    this.dialogRef.close();
  }


  printAndSave(type:string) {
    console.log('Selected Report Type :', this.selectedReportType);
    if (this.selectedReportType) {
      this.dialogRef.close({
        success: true,
        action:type,
        formData: this.selectedReportType, 
      });
    } else {
      console.error('No report type selected');
    }
  }
}
